<template>

  <a-card :bordered="false">
    <a-form ref='form' :model='search' :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
      <a-form-item label="二维码号" name='keyword'>
        <a-input style="width: 270px" v-model:value="search.keyword" placeholder="请输入关键词进行搜索" />
      </a-form-item>
      <a-form-item>
        <a-button type="primary" htmlType='submit'>搜索</a-button>
      </a-form-item>
    </a-form>
    <a-table class='m-t-25' :pagination='false' :loading='loading' bordered rowKey='product_sn' :columns='columns' :data-source='list'>
     <template v-slot:code_sn="{ record }">
      <a href="javascript:;" v-has:antiAuditQuery='()=>{$router.push("/antiFleeingGoods/marketAudit/tracking?code="+record.code_sn)}'>{{record.code_sn}}</a>
      </template>
      <template v-slot:gift_name="{ record }">
        <a-card-meta>
          <template #avatar>
            <img :src="info.picdomain+'/'+(record.product_image)" alt="" style="width:50px;height:50px">
          </template>
          <template #description>
            <p class="s_omit2" style="width: 320px;">{{record.product_name}}</p>
          </template>
        </a-card-meta>
      </template>
      <!-- <template v-slot:action="{ record }">
        <a-button type="link" @click='goodsItem = record.product[0];showCode = true;'>查看出货二维码</a-button>
      </template> -->
    </a-table>
    <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `"  />
  </a-card>
</template>

<script>
import { ref, onMounted, inject, reactive, toRefs, h } from "vue";
import { message } from "ant-design-vue";
import store from "@/store";
import { getTransFerWarehousingCode } from "@/api/antiFleeing";
import { iscode } from "@/utils/app";
export default {
  components: {  },
  props: { id: String },
  setup(props) {
    const search = ref({
      page: 1,
      limit: 5,
      keyword: "",
    });
    const state = reactive({
      info: store.state.user.info,
      list: [],
      loading: false,
      total:0,
      columns: [
        {
          title: "二维码号",
          dataIndex: "code_sn",
          key: "code_sn",
              slots: { customRender: "code_sn" },
        },
        {
          title: "二维码类型",
          dataIndex: "code_type_text",
          key: "code_type_text"
        },
        {
          title: "商品名称",
          dataIndex: "product_sku_name",
          key: "product_sku_name",
          slots: { customRender: "gift_name" },
        },
        {
          title: "商品规格",
          dataIndex: "out_warehousing_num",
          key: "out_warehousing_num",
          customRender: ({ record }) => {
            return (record.product_sku_name&&record.product_sku_name!='0') ? record.product_sku_name : "单规格";
          },
        },
        {
          title: "商品数量",
          dataIndex: "code_num",
          key: "code_num",
        },
        // {
        //   title: "入库仓库",
        //   dataIndex: "out_warehousing_real_num",
        //   key: "out_warehousing_real_num",
        //   customRender: ({ record }) => {
        //     return record.warehouse_position_name || "-";
        //   },
        // },
      ],
    });
    // 页面筛选项搜索
    const pageSearchChange = () => {
      search.value = { ...search.value, page: 1 };
      initData();
    };
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
      initData();
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      search.value.page = 1;
      search.value.limit = limit;
      initData();
    };
    //获取列表
    const initData = async () => {
      state.listLoading = true;
      let res = await getTransFerWarehousingCode({
        ...search.value,
        sn: props.id,
      }).then((res) => res.data);
      state.listLoading = false;
      if (iscode(res)) {
        state.list = res.data;
        state.total = res.meta.total;
      } else {
        message.error(res.msg);
      }
      state.listLoading = false;
    };
    onMounted(() => {
      initData();
    });
    return {
      ...toRefs(state),
      search,
      pageSearchChange,
      pageCurrentChange,
      pageSizeChange,
    };
  },
};
</script>